import React, { useEffect } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import BorrowerAuthCert from "../../../components/loan_tools/forms/borrower_auth_cert";
import FormEmailButton from "../../../components/loan_tools/forms/form_email_button";
import { useDocument } from "../../../components/loan_tools/loan_tool";

export default function BorrowerAuthCertRoute() {
  const [loanDoc, , , actions] = useDocument();

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName ? `${lastName} – Borrower Auth & Cert` : "Borrower Auth & Cert";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  return (
    <StandardTemplate className="ba-template">
      <div className="ba-page-actions no-print">
        <button className="button" onClick={() => window.print()}>Save / Print PDF</button>
        <FormEmailButton docName="Borrower Authorization and Certification" />
      </div>
      <BorrowerAuthCert />
    </StandardTemplate>
  );
}
